import React from 'react';
import type { FC } from 'react';

interface LayerIconProps {
    className?: string;
}

export const LayerIcon: FC<LayerIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Layer Icon</title>
            <rect x="2.79844" y="2.80027" width="11.2" height="11.2" rx="1.2" stroke="white" strokeWidth="0.8" />
            <path d="M6.72699 7.03748V6.32754H10.0719V7.03748H8.825V10.4003H7.97386V7.03748H6.72699Z" fill="white" />
            <rect width="16" height="16" rx="3.2" fill="#32EAA7" />
            <g clipPath="url(#clip0_1570_9013)">
                <g clipPath="url(#clip1_1570_9013)">
                    <path
                        d="M6 10L10 6"
                        stroke="#192028"
                        strokeWidth="0.8"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7.33594 4.00041L7.6446 3.64307C8.26981 3.01796 9.11773 2.66681 10.0018 2.66687C10.8859 2.66693 11.7338 3.0182 12.3589 3.64341C12.9841 4.26861 13.3352 5.11653 13.3351 6.00064C13.3351 6.88475 12.9838 7.73263 12.3586 8.35774L12.0026 8.66707"
                        stroke="#192028"
                        strokeWidth="0.8"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.66416 11.9998L8.39949 12.3558C7.76699 12.9813 6.91335 13.332 6.02382 13.332C5.1343 13.332 4.28066 12.9813 3.64816 12.3558C3.3364 12.0475 3.08889 11.6805 2.91996 11.2759C2.75104 10.8713 2.66406 10.4372 2.66406 9.9988C2.66406 9.56036 2.75104 9.12629 2.91996 8.7217C3.08889 8.31712 3.3364 7.95006 3.64816 7.6418L3.99749 7.33313"
                        stroke="#192028"
                        strokeWidth="0.8"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_1570_9013">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <clipPath id="clip1_1570_9013">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
